<div class="modal-header">
  <h4 [innerHTML]="modalTitle" class="modal-title h5"></h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <scitis-select-machines-dropdown
    [organizationId]="organizationId"
    (selectedMachineIds)="onUpdateSelectedMachines($event)">
  </scitis-select-machines-dropdown>

  @if (selectedMachineIds && selectedMachineIds.length > 0) {
    <div [innerHtml]="modalCloningProcessNotification"
      class="alert alert-info">
    </div>
  }
</div>

<scitis-modal-footer (cancelButtonPressed)="onCancel()"
  (okButtonPressed)="onCopyStatusEventPage()"
  [cancelButtonText]="'Cancel'|translate"
  [disableOkButton]="shouldDisableCopyButton"
  [okButtonText]="'Copy'|translate"
  [showRequiredFieldsIndicator]="false">

</scitis-modal-footer>